// Camera URLs cover the globe; search query coordinates keep their separate country contract.
export const wrapLongitude = lon => ((lon + 180) % 360 + 360) % 360 - 180;
export function cameraFromURL(params) {
  const lat=Number(params.get('lat')),lon=Number(params.get('lon')),zoom=Number(params.get('z'));
  const position=params.has('lat')&&params.has('lon')&&Number.isFinite(lat)&&Number.isFinite(lon)
    &&lat>=-90&&lat<=90&&lon>=-180&&lon<=180?[lon,lat]:null;
  return {position,zoom:Math.min(19,Math.max(0,params.has('z')&&Number.isFinite(zoom)?zoom:15))};
}
